import * as React from "react";
import { FunctionComponent, useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { AutoClaimReport, ClaimType } from "../../../Models/Claim";
import FileDragAndDrop from "../../FileDragAndDrop";
import { FilesTable } from "../../FilesTable";

import ReactTooltip from 'react-tooltip';
import { ByteLimit } from "../../../Utils";
import { Collapse } from "react-bootstrap";
interface StepThreeProps {
    goBack: (step: number, claim: AutoClaimReport, validate: boolean) => void;
    claim: AutoClaimReport;
    showError: boolean;
}

export const StepThree: FunctionComponent<StepThreeProps> = ({ goBack, claim, showError }) => 
{
    const [shouldScroll, setShouldScroll] = useState<boolean>(true);
    const [width, setWidth] = useState<number>(window.innerWidth);
    const [otherVehicleYear, setOtherVehicleYear] = useState<string>(claim.otherPropertyVehicleYear);
    const [otherVehicleMake, setOtherVehicleMake] = useState<string>(claim.otherPropertyVehicleMake);
    const [otherVehicleModel, setOtherVehicleModel] = useState<string>(claim.otherPropertyVehicleModel);
    const [otherVehicleVIN, setOtherVehicleVIN] = useState<string>(claim.otherPropertyVehicleVIN);
    const [otherPropertyDamage, setOtherPropertyDamage] = useState<string>(claim.otherPropertyDamage);
    const [otherPropertyDescription, setOtherPropertyDescription] = useState<string>(claim.otherPropertyDescription);
    const [otherPropertyDamageOwnerName, setOtherPropertyDamageOwnerName] = useState<string>(claim.otherPropertyOwnersName);
    const [otherPropertyDamageOwnerAddress, setOtherPropertyDamageOwnerAddress] = useState<string>(claim.otherPropertyOwnersAddress);
    const [otherPropertyDamageOwnerPhone, setOtherPropertyDamageOwnerPhone] = useState<string>(claim.otherPropertyOwnersPhone);
    const [otherPropertyDamageOwnerAltPhone, setOtherPropertyDamageOwnerAltPhone] = useState<string>(claim.otherPropertyOwnersAltPhone);
    const [otherPropertyDamageOwnerInsurance, setOtherPropertyDamageOwnerInsurance] = useState<string>(claim.otherPropertyOwnersCompAgency);
    const [otherPropertyDamageOwnerPolicy, setOtherPropertyDamageOwnerPolicy] = useState<string>(claim.otherPropertyOwnersPolicy);
    const [otherPropertyDamageVehicleName, setOtherPropertyDamageVehicleName] = useState<string>(claim.otherPropertyVehicleDriverName);
    const [otherPropertyDamageVehicleAddress, setOtherPropertyDamageVehicleAddress] = useState<string>(claim.otherPropertyVehicleDriverAddress);
    const [otherPropertyDamageDescription, setOtherPropertyDamageDescription] = useState<string>(claim.otherPropertyDamageDescription);
    const [otherPropertyDamageEstimation, setOtherPropertyDamageEstimation] = useState<string>(claim.otherPropertyDamageAmount);
    const [otherPropertyDamageLocation, setOtherPropertyDamageLocation] = useState<string>(claim.otherPropertyDamageLocation);
    const [word, setWord] = useState<string>(getLocalStorage("autoclaim-stepthree-word"));
    useEffect(() => {
		if (shouldScroll) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setShouldScroll(false);
		}
	}, [shouldScroll])

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    
    function getLocalStorage(key: string) {
		return localStorage.getItem(key) || ""
	}

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile: boolean = (width <= 768);

    return <div className="step-three">
    <div className="form-group other-property">
        <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="any-property-damage">Was any other property damaged<span className="red-ast">*</span>?</label>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <select className="form-control" id="any-property-damage" aria-invalid={showError && otherPropertyDamage === ""} aria-describedby="otherPropertyDamagedError" name="Was any other property damaged?" value={otherPropertyDamage} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setOtherPropertyDamage(e.target.value);
                if (e.target.value === "Another Vehicle")
                {
                    setWord("Vehicle");
                    localStorage.setItem("autoclaim-stepthree-word", "Vehicle");
                }
                else 
                {
                    setWord("Property");
                    localStorage.setItem("autoclaim-stepthree-word", "Property");
                }
            }}>
                <option value="">Select...</option>
                <option value="No Other Property Damage">No Other Property Damage</option>
                <option value="Another Vehicle">Another Vehicle</option>
                <option value="Other">Other</option>
            </select>
            <p id="otherPropertyDamagedError" className={showError && otherPropertyDamage === "" ? "error" : "error-hidden"}>This field is required</p>
        </div>
    </div>
    <Collapse in={otherPropertyDamage !== "No Other Property Damage" && otherPropertyDamage !== ""}>
        <div>
            <Collapse in={otherPropertyDamage === "Other"}>
            <div className="form-group describe-property">
                <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="describe-property">Describe Property:</label>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <input className="form-control" type="text" id="describe-property" maxLength={92} placeholder="Broken Fence" name="Describe Property" value={otherPropertyDescription} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setOtherPropertyDescription(e.target.value);
                    }}/>
                </div>
            </div>
            </Collapse>
            <Collapse in={otherPropertyDamage === "Another Vehicle"}>
                <div>
                    <div className="form-group">
                        <p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Other Vehicle Involved in Accident?</p>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-2 col-md-4 col-sm-4 col-xs-4">
                            <label className="control-label sr-only" htmlFor="other-vehicle-year">Year:</label>
                            <input className="form-control" max-length={4} type="text" inputMode="numeric" pattern="[0-9]*" id="other-vehicle-year" placeholder="2021" name="Other Vehicle Year" value={otherVehicleYear} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherVehicleYear(e.target.value.replace(/\D/g, ''));
                            }} />
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-5 col-xs-5">
                            <label className="control-label sr-only" htmlFor="other-vehicle-make">Make:</label>
                            <input className="form-control" type="text" id="other-vehicle-make" placeholder="Toyota" name="Other Vehicle Make" value={otherVehicleMake} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherVehicleMake(e.target.value);
                            }} />
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12 mobile-padding-top-xs">
                            <label className="control-label sr-only" htmlFor="other-vehicle-model">Model:</label>
                            <input className="form-control" type="text" id="other-vehicle-model" maxLength={30} placeholder="Corolla" name="Other Vehicle Model" value={otherVehicleModel} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherVehicleModel(e.target.value);
                            }} />
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 mobile-padding-top">
                            <label className="sr-only" htmlFor="other-vehicle-vin">Vehicle License Plate:</label>
                            <input className="form-control" type="text" id="other-vehicle-vin" placeholder="Vehicle License Plate" name="Other Vehicle License Plate" maxLength={9} value={otherVehicleVIN} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherVehicleVIN(e.target.value);
                            }} />
                        </div>
                    </div>
                    <div className="form-group property-owner-driver">
                        <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-driver-name">Driver Name:</label>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <input className="form-control" type="text" maxLength={45} id="property-owner-driver-name" placeholder="John Smith" name="Name of driver of vehicle" value={otherPropertyDamageVehicleName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherPropertyDamageVehicleName(e.target.value);
                            }}/>
                        </div>
                    </div>
                    <div className="form-group property-owner-driver-address">
                        <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-driver-address">Driver Address:</label>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <input className="form-control" type="text" maxLength={55} id="property-owner-driver-address" placeholder="123 Main Street" name="Address of driver if vehicle" value={otherPropertyDamageVehicleAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setOtherPropertyDamageVehicleAddress(e.target.value);
                            }}/>
                        </div>
                    </div>
                </div>
            </Collapse>
            <div className="other-property-info">
                <div className="form-group propery-owner-name">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-name">{word} Owner's Name:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" type="text" id="property-owner-name" maxLength={45} placeholder="John Smith" name="Property owner's name" value={otherPropertyDamageOwnerName} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageOwnerName(e.target.value);
                        }}/>
                    </div>
                </div>
                <div className="form-group property-owner-address">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-address">{word} Owner's Address:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" type="text" maxLength={55} id="property-owner-address" placeholder="123 Main Street" name="Property owner's address" value={otherPropertyDamageOwnerAddress} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageOwnerAddress(e.target.value);
                        }}/>
                    </div>
                </div>
                <div className="form-group property-owner-phone">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-phone">{word} Owner's Number:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <PhoneInput id="property-owner-phone" placeholder="(123)-456-7890" name="Property Owner's Phone" aria-invalid={showError && (otherPropertyDamageOwnerPhone !== "" && !isValidPhoneNumber(otherPropertyDamageOwnerPhone))} aria-describedby="otherPropertyPhone" country="US" international={false} className="form-control" value={otherPropertyDamageOwnerPhone} maxLength={14} onChange={(phone: string) =>{
                            if (!phone) phone = "";
                                setOtherPropertyDamageOwnerPhone(phone);
                        }}/>
                        <p id="otherPropertyPhone" className={showError && (otherPropertyDamageOwnerPhone !== "" && !isValidPhoneNumber(otherPropertyDamageOwnerPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                    </div>
                </div>
                <div className="form-group property-owner-altphone">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-altphone">{word} Owner's Alternate Number:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <PhoneInput id="property-owner-altphone" placeholder="(123)-456-7890" name="Property Owner's Alternate Phone" aria-invalid={showError && (otherPropertyDamageOwnerAltPhone !== "" && !isValidPhoneNumber(otherPropertyDamageOwnerAltPhone))} aria-describedby="otherPropertyAltPhone" country="US" international={false} className="form-control" value={otherPropertyDamageOwnerAltPhone} maxLength={14} onChange={(phone: string) =>{
                            if (!phone) phone = "";
                                setOtherPropertyDamageOwnerAltPhone(phone);
                        }}/>
                        <p id="otherPropertyAltPhone" className={showError && (otherPropertyDamageOwnerAltPhone !== "" && !isValidPhoneNumber(otherPropertyDamageOwnerAltPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                    </div>
                </div>
                <div className="form-group property-owner-company">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-company">Insurance Company or Agency Name:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" maxLength={45} type="text" id="property-owner-company" placeholder="Company Name" name="Property owner's Company or Agency Name" value={otherPropertyDamageOwnerInsurance} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageOwnerInsurance(e.target.value);
                        }}/>
                    </div>
                </div>
                <div className="form-group property-owner-policy">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-policy">Policy Number (if known):</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" maxLength={50} type="text" id="property-owner-policy" placeholder="ABC123456" name="Property owner's Policy Number if known" value={otherPropertyDamageOwnerPolicy} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageOwnerPolicy(e.target.value);
                        }}/>
                    </div>
                </div>

                <div className="form-group property-owner-damage">
                    <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="property-owner-damage">Describe Damage:</label>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <textarea className="form-control" id="property-owner-damage" aria-describedby="otherDamageDescription" maxLength={325} rows={4} placeholder="Damage was done to property" name="Describe damage that was done" value={otherPropertyDamageDescription} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                            setOtherPropertyDamageDescription(e.target.value);
                        }}/>
                        <p id="otherDamageDescription"><strong>Maximum 325 characters.  You have used {otherPropertyDamageDescription.length} characters.</strong></p>
                    </div>
                </div>
                <div className="form-group property-owner-estimation">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-estimation">Estimation Amount (if known):</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" type="text" id="property-owner-estimation" maxLength={10} placeholder="$ Amount or Unknown" name="Estimated amount of damage" value={otherPropertyDamageEstimation} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageEstimation(e.target.value);
                        }}/>
                    </div>
                </div>
                <div className="form-group property-owner-location">
                    <label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="property-owner-location">Describe location where {word.toLocaleLowerCase()} damage can be seen:</label>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <input className="form-control" type="text" id="property-owner-location" maxLength={62} placeholder="123 Main Street, Town, State" name="Property Damage Location" value={otherPropertyDamageLocation} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setOtherPropertyDamageLocation(e.target.value);
                        }}/>
                    </div>
                </div>
                <div className="form-group">
                    <p><strong>*If there is any additional damaged property, please add to the remarks section at the end</strong></p>
                </div>
            </div>
        </div>
    </Collapse>
    <div className="form-group button-group">
        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(3); }}><i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;BACK</button>
        <button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(5, showError ? true : false);}}><i className="fa fa-arrow-right" aria-hidden="true" />&nbsp;NEXT</button>
    </div>
</div>;

    function updateClaim()
    {
        claim.otherPropertyDamage = otherPropertyDamage;
        claim.otherPropertyDescription = otherPropertyDescription;
        claim.otherPropertyVehicleMake = otherVehicleMake;
        claim.otherPropertyVehicleYear = otherVehicleYear;
        claim.otherPropertyVehicleModel = otherVehicleModel;
        claim.otherPropertyVehicleVIN = otherVehicleVIN;
        claim.otherPropertyOwnersName = otherPropertyDamageOwnerName;
        claim.otherPropertyOwnersAddress = otherPropertyDamageOwnerAddress;
        claim.otherPropertyOwnersPhone = otherPropertyDamageOwnerPhone;
        claim.otherPropertyOwnersAltPhone = otherPropertyDamageOwnerAltPhone;
        claim.otherPropertyOwnersCompAgency = otherPropertyDamageOwnerInsurance;
        claim.otherPropertyOwnersPolicy = otherPropertyDamageOwnerPolicy;
        claim.otherPropertyVehicleDriverName = otherPropertyDamageVehicleName;
        claim.otherPropertyDamageDescription = otherPropertyDamageDescription;
        claim.otherPropertyDamageAmount = otherPropertyDamageEstimation;
        claim.otherPropertyDamageLocation = otherPropertyDamageLocation;

        return claim;
    }

    function goToStep(step: number, validate:boolean = false)
    {
        goBack(step,updateClaim(),validate);
    }
}
